import template from './auditsbymonth.html';
import controller from './auditsbymonth.controller';
import './auditsbymonth.styl';

let auditsbymonthComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default auditsbymonthComponent;



// WEBPACK FOOTER //
// ./client/app/common/reports/auditsbymonth/auditsbymonth.component.js